import script from "./ClientDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientDashboard.vue?vue&type=script&setup=true&lang=js"

import "./ClientDashboard.vue?vue&type=style&index=0&id=7637875c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7637875c"]])

export default __exports__